import React from 'react';
import {LMessages} from '../../Localization/Localization';
import {IPageInterface} from '../entity/IPageInterface';
import {ReportByOrganizationFields, ReportByTutorFields} from './fields';
import {createCommonRequest, ICommonRequest} from './ReportInterfaces';
import {UniversalReportPage} from './UniversalReportPage';

export const TutorReport = ({}: IPageInterface) => {
  return (
    <UniversalReportPage<ICommonRequest>
      action={'REPORT_TUTORS'}
      emptyEntity={createCommonRequest()}
      fields={ReportByTutorFields}
      title={LMessages.REPORT_TUTORS_CARD_TITLE}
    />
  );
};
